import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { PermissionType } from "../common/interfaces/enums/PermissionType";
import { UserType } from "../common/interfaces/enums/UserType";
import { CommonRoutesConfig, Register } from "./RoutesConfig";
import useUserContext from "../hooks/useUserContext";

type ProtectedRouteProps = {
  children: ReactNode;
  userTypes?: UserType[];
  register?: Register;
  permissionType?: PermissionType;
};

const ProtectedRoute = ({ children, userTypes, register, permissionType }: ProtectedRouteProps) => {
  const location = useLocation();
  const { isAuthenticated, hasPermissions } = useUserContext();

  //const isCommonRoute = CommonRoutesConfig.isRouteCommon(location.pathname);

  if (!isAuthenticated) {
    return (
      <Navigate
        to={{
          pathname: CommonRoutesConfig.Login.Path,
        }}
        state={{ from: location }}
      />
    );
  } else if (!hasPermissions(register, permissionType, userTypes)) {
    return (
      <Navigate
        to={{
          pathname: CommonRoutesConfig.Forbidden.Path,
        }}
        state={{ from: location }}
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
